<div class="clientlist-container">
  <div class="clientlist-content">

    <!-- ── Header ── -->
    <div class="list-header">
      <h5>List of Clients <span *ngIf="!isLoading && dataSource.length > 0" class="leads-count-badge">{{ dataSource.length }}</span></h5>

      <div class="list-actions">

        <!-- Search Box -->
        <div class="search-box">
          <div class="input-group">
            <span class="input-group-text bg-transparent" style="border: 0px !important">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              style="padding: 0px !important; border: 0px !important"
              placeholder="Search by name, email, phone..."
              [(ngModel)]="searchQuery"
              (input)="onSearch()"
              (keyup.enter)="onSearch()">
            <span class="input-group-text bg-transparent clear-btn-wrap"
                  *ngIf="searchQuery"
                  (click)="clearSearch()"
                  style="cursor: pointer;">
              <i class="bi bi-x-circle"></i>
            </span>
          </div>
        </div>
                
        <!-- Account Type Tabs -->
        <div class="account-type-tabs">
        
          <!-- SuperUser Only -->
          <button *ngIf="role === 'SuperUser'" class="account-tab" [class.active]="accountTypeFilter === 'all'"
            (click)="selectAccountType('all')">
            All
          </button>
        
          <!-- Everyone -->
          <button class="account-tab" [class.active]="accountTypeFilter === 'client'" (click)="selectAccountType('client')">
            Clients
          </button>
        
          <!-- SuperUser + Support -->
          <button *ngIf="role === 'SuperUser' || role === 'Support'" class="account-tab"
            [class.active]="accountTypeFilter === 'demo'" (click)="selectAccountType('demo')">
            Demo
          </button>
        
          <!-- SuperUser + Support -->
          <button *ngIf="role === 'SuperUser' || role === 'Support'" class="account-tab"
            [class.active]="accountTypeFilter === 'test'" (click)="selectAccountType('test')">
            Test Account
          </button>
        
        </div>

      </div>
    </div>

    <!-- ── Table ── -->
    <div class="clients-table" [class.loading]="isLoading"
         *ngIf="!isLoading && dataSource.length > 0">
      <table class="table">
        <thead>
          <tr>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('name')">
              Name <i class="bi sort-icon" [ngClass]="getSortIcon('name')"></i>
            </th>
            <th class="thdata sortable-col hide-md" scope="col" (click)="sortBy('email')">
              Email <i class="bi sort-icon" [ngClass]="getSortIcon('email')"></i>
            </th>
            <th class="thdata hide-md" scope="col">Phone Number</th>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('account_activation_date')">
              Account Activation Date <i class="bi sort-icon" [ngClass]="getSortIcon('account_activation_date')"></i>
            </th>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('last_login')">
              Last Login <i class="bi sort-icon" [ngClass]="getSortIcon('last_login')"></i>
            </th>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('terms')">
              T&amp;C Signed On <i class="bi sort-icon" [ngClass]="getSortIcon('terms')"></i>
            </th>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('status')">
              Status <i class="bi sort-icon" [ngClass]="getSortIcon('status')"></i>
            </th>
            <th class="thdata sortable-col" scope="col">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let client of getPage()">
            <td>
              <div class="client-name-wrap">
                <a class="client-name-link"
                   href="javascript:void(0)"
                   title="View client history"
                   (click)="openClientHistory(client)">
                  {{ client.name || '-' }}
                </a>
            
                <span *ngIf="client.account_type" class="account-type-badge" [ngClass]="{
                    'badge-client': client.account_type === 'client',
                    'badge-demo': client.account_type === 'demo',
                    'badge-test': client.account_type === 'internal_test'
                  }">
                  {{
                  client.account_type === 'internal_test'
                  ? 'Test Account'
                  : (client.account_type | titlecase)
                  }}
                </span>
              </div>
            </td>
            <td class="hide-md email-cell">
              <a *ngIf="client.email" [href]="'mailto:' + client.email" class="email-link">
                {{ client.email }}
              </a>
              <span *ngIf="!client.email">-</span>
            </td>
            <td class="hide-md">{{ client.phone || '-' }}</td>
            <td>{{ formatDate(client.account_activation_date) }}</td>
            <td>{{ client.last_login ? formatDateTime(client.last_login) : 'Never' }}</td>
            <td>{{ getTermsDate(client.terms) }}</td>
            <td>
              <span class="status-badge" [ngClass]="getStatusClass(client.status)">
                {{ client.status || '-' }}
              </span>
            </td>

             <!-- Three-dot Actions -->
              <td>
                <div class="action-menu-wrap" (click)="$event.stopPropagation()">
                  <button class="action-btn three-dot-btn" (click)="toggleActionMenu(client.id, $event)" title="Actions">
              
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
              
                  <div class="action-dropdown" *ngIf="activeMenuUid === client.id">
              
                    <button class="action-dd-item"
                      (click)="openClientHistory(client); activeMenuUid = null">

                      <i class="bi bi-clock-history"></i>
                      View History
                    </button>

                    <button class="action-dd-item account-type-item upgrade-item"
                      (click)="openAccountTypeModal(client); activeMenuUid = null">
              
                      <i class="bi bi-person-circle"></i>
                      Account Type
                    </button>
              
                  </div>
                </div>
              </td>
                
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ── Skeleton loader ── -->
    <div *ngIf="isLoading" class="skeleton-wrapper">
      <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7,8]">
        <div class="skeleton-cell wide"></div>
        <div class="skeleton-cell wide hide-md"></div>
        <div class="skeleton-cell medium hide-md"></div>
        <div class="skeleton-cell medium"></div>
        <div class="skeleton-cell medium"></div>
        <div class="skeleton-cell medium"></div>
        <div class="skeleton-cell medium"></div>
        <div class="skeleton-cell medium"></div>
      </div>
    </div>

    <!-- ── No Data ── -->
    <div *ngIf="!isLoading && dataSource.length === 0" class="empty-state">
      <i class="bi bi-person-slash empty-icon"></i>
      <p class="empty-title">
        {{ searchQuery ? 'No results found' : 'No Lexiz Clients Found' }}
      </p>
      <p class="empty-sub">
        {{ searchQuery ? 'Try adjusting your search.' : 'There are currently no consumers with plan = lexiz.' }}
      </p>
    </div>

    <!-- ── Pagination ── -->
    <div class="pagination-area" *ngIf="!isLoading && dataSource.length > 0">
      <div class="pagination-info">{{ getPaginationRange() }}</div>
      <nav aria-label="Client list pagination">
        <ul class="pagination mb-0">
          <li class="page-item" [ngClass]="{'disabled': pageIndex === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="goToFirstPage()">
              <i class="bi bi-chevron-double-left biarr"></i>
            </a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="goToPrevPage()">
              <i class="bi bi-chevron-left biarr"></i> Previous
            </a>
          </li>
          <li *ngFor="let page of getPageNumbers()" class="page-item"
              [ngClass]="{'active': page === pageIndex + 1}">
            <a class="page-link" href="javascript:void(0)"
               (click)="goToPage(page - 1)">{{ page }}</a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex >= getTotalPages() - 1}">
            <a class="page-link" href="javascript:void(0)" (click)="goToNextPage()">
              Next <i class="bi bi-chevron-right biarr"></i>
            </a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex >= getTotalPages() - 1}">
            <a class="page-link" href="javascript:void(0)" (click)="goToLastPage()">
              <i class="bi bi-chevron-double-right biarr"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>

  </div>
</div>




<!-- ══════════════════════════════════════════════════════════
     Account type MODAL
══════════════════════════════════════════════════════════ -->
<div class="status-modal-overlay" *ngIf="showAccountTypeModal">
  <div class="status-modal">

    <h3 class="status-title">Update Account Type</h3>

    <div class="status-options">

      <button class="status-btn" [class.active]="selectedAccountType === 'client'" (click)="selectedAccountType = 'client'">
        Client
      </button>

      <button class="status-btn" [class.active]="selectedAccountType === 'demo'" (click)="selectedAccountType = 'demo'">
        Demo
      </button>

      <button class="status-btn" [class.active]="selectedAccountType === 'internal_test'" (click)="selectedAccountType = 'internal_test'">
        Test Account
      </button>

    </div>

    <div class="status-actions">
      <button class="btn-cancel" (click)="closeAccountTypeModal()">
        Cancel
      </button>

      <button class="btn-update" (click)="updateAccountType()">
        Update
      </button>
    </div>

  </div>
</div>


<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true">
</ngx-spinner>